import { render, staticRenderFns } from "./AccommodationSelect.vue?vue&type=template&id=2a8a5302&"
import script from "./AccommodationSelect.vue?vue&type=script&lang=js&"
export * from "./AccommodationSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports